module.exports = __webpack_public_path__ + "static/img/p2.7de54fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/myshadow-myshelter/p2.png
// module id = k2dm
// module chunks = 0